import { createFileRoute } from '@tanstack/react-router';
import { PrivacyPage } from '@/components/marketing/pages/PrivacyPage';

export const Route = createFileRoute('/_marketing/legal/privacy')({
  component: PrivacyPage,
});
